import { useMemo } from 'react';
import { SubtractNriTable } from './subtract-nri-table';
import type { SlotAllocationRow } from './types';
import styles from './slot-allocation-expanded-row.module.scss';

interface SlotAllocationExpandedRowProps {
  row: SlotAllocationRow;
}

/**
 * Expanded content for a Slot Allocation row: only the shared Subtract-NRI table
 * (verification removed in P1). Slot Allocation rows are leaf entities per the
 * mock — there are no nested tract-allocation children. Renders nothing when the
 * row has no subtracts.
 *
 * @param {SlotAllocationExpandedRowProps} props - The parent slot-allocation row.
 * @return {JSX.Element | null} The subtract-NRI table, or null when empty.
 */
export function SlotAllocationExpandedRow({
  row,
}: SlotAllocationExpandedRowProps) {
  const subtracts = useMemo(() => row.subtracts ?? [], [row.subtracts]);
  if (subtracts.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.nestedTable}>
        <SubtractNriTable
          subtracts={subtracts}
          parentRowId={String((row as unknown as { id?: unknown }).id ?? '')}
        />
      </div>
    </div>
  );
}
